import { CartItem, QuantityLimitedProduct } from "../types/cart.types";

export const getCartQuantity = (
  productId: string,
  cart: CartItem[] | Record<string, CartItem> | null,
) => {
  if (!cart) return 0;

  if (Array.isArray(cart)) {
    const item = cart.find((it) => it.productId === productId);
    if (!item) return 0;

    return item.type === "weight" ? (item.weight ?? 0) : (item.quantity ?? 0);
  } else {
    const item = cart[productId];
    if (!item) return 0;

    return item.type === "weight" ? (item.weight ?? 0) : (item.quantity ?? 0);
  }
};

export function getMaxOrderQuantity(product: QuantityLimitedProduct | null | undefined): number {
  const inventory = Number(product?.quantity);
  const perOrder = Number(product?.maxQuantityOfProduct);
  const candidates: number[] = [];
  if (Number.isFinite(inventory) && inventory > 0) candidates.push(inventory);
  if (Number.isFinite(perOrder) && perOrder > 0) candidates.push(perOrder);
  return candidates.length > 0 ? Math.min(...candidates) : Number.POSITIVE_INFINITY;
}